import React from 'react';

import { Icon } from '@/components/shared/element/icons';
import { Text } from '@/components/shared/element/text';
import { Box } from '@/components/shared/layout/box';
import { Container } from '@/components/shared/layout/container';
import { Flex } from '@/components/shared/layout/flex';

interface DealerSearchFilterMobileDisplayToggleProps {
  hideFilter: boolean;
  onClickToggle: () => void;
}

export const DealerSearchFilterMobileDisplayToggle = React.forwardRef<
  HTMLDivElement,
  DealerSearchFilterMobileDisplayToggleProps
>((props, ref) => {
  return (
    <Box display={{ '@lg': 'none' }} backgroundColor="gray300">
      <Container ref={ref}>
        <Flex
          alignItems="center"
          justifyContent="center"
          rowGap="2"
          css={{ cursor: 'pointer', py: '$space-3' }}
          onClick={props.onClickToggle}
        >
          <Text font="bold" variant="text-gray">
            {props.hideFilter ? 'แสดงตัวกรอง' : 'ซ่อนตัวกรอง'}
          </Text>
          <Icon
            icon={props.hideFilter ? 'expand-more' : 'expand-less'}
            color="icon-gray-light"
          />
        </Flex>
      </Container>
    </Box>
  );
});

DealerSearchFilterMobileDisplayToggle.displayName =
  'SectionDealerSearchFilterMobileDisplayToggle';
